export default __webpack_public_path__ + "6478c0e8e0912e246c2dda3d5f31eace.svg";